import { useState, useEffect } from "react";

export default function useExplosion(board, explosion) {
  const [ballBoard, setBallBoard] = useState([]);
  const [currentMine, setCurrentMine] = useState("");
  const [mineLocation, setMineLocation] = useState(false);

  const [ballsAround, setBallsAround] = useState([]);

  useEffect(() => {
    setBallBoard(board);
  }, [board]);

  useEffect(() => {
    if (ballBoard) {
      setCurrentMine(ballBoard.indexOf("3").toString());
    }
  }, [ballBoard]);

  useEffect(() => {
    if (!explosion) {
      setBallsAround([]);
      setMineLocation(false);
    }
  }, [explosion]);

  useEffect(() => {
    const ExplosionTypes = {
      left: ["5", "10", "15", "20"],
      right: ["9", "14", "19", "24"],
      top: ["1", "2", "3"],
      bottom: [
        "21",
        "22",
        "23",
        "6",
        "7",
        "8",
        "11",
        "12",
        "13",
        "16",
        "17",
        "18",
      ],
      leftTopCorner: ["0"],
      rightTopCorner: ["4"],
    };
    const {
      top,
      bottom,
      left,
      right,
      rightTopCorner,
      leftTopCorner,
    } = ExplosionTypes;

    if (explosion) {
      switch (true) {
        case left.includes(currentMine):
          setMineLocation("left");
          break;
        case right.includes(currentMine):
          setMineLocation("right");
          break;
        case top.includes(currentMine):
          setMineLocation("top");
          break;
        case bottom.includes(currentMine):
          setMineLocation("bot");
          break;
        case leftTopCorner.includes(currentMine):
          setMineLocation("leftTop");
          break;
        case rightTopCorner.includes(currentMine):
          setMineLocation("rightTop");
          break;
        default:
          break;
      }
    }
  }, [currentMine, explosion]);

  useEffect(() => {
    if (explosion) {
      let mine = parseInt(currentMine);
      let arr = [];
      switch (true) {
        case mineLocation === "left":
          arr.push(mine - 4, mine + 2);
          setBallsAround(arr);
          break;
        case mineLocation === "right":
          arr.push(mine, mine - 4);
          setBallsAround(arr);
          break;
        case mineLocation === "top":
          arr.push(mine, mine + 2);
          setBallsAround(arr);
          break;
        case mineLocation === "bot":
          arr.push(mine, mine - 4, mine + 2);
          setBallsAround(arr);
          break;
        case mineLocation === "rightTop":
          arr.push(mine, mine + 6);
          setBallsAround(arr);
          break;
        case mineLocation === "leftTop":
          arr.push(mine + 2, mine + 6);
          setBallsAround(arr);
          break;
        default:
          break;
      }
    }
  }, [explosion, currentMine, mineLocation]);
  return [ballBoard, currentMine, mineLocation, ballsAround];
}
